<div class="full-height layout-column">
  <app-bringoz-items-list-display [items]="itemsDisplay" maxItems="1"></app-bringoz-items-list-display>
</div>
